import { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import GET_CLASSIFICATION_PERFORMANCE_ITEMS from '@shared/queries/getClassificationPerformanceItemsQuery';
import { ClassificationMetricMapper } from '@shared/mappers/classificationMetricMapper';

const useClassificationMetricList = () => {
  const { data, loading, error } = useQuery(GET_CLASSIFICATION_PERFORMANCE_ITEMS);

  const classificationMetrics = useMemo(() => {
    if (!data) {
      return [];
    }

    return data.classificationPerformanceItems.map(ClassificationMetricMapper.toListItem);
  }, [data]);

  return {
    classificationMetrics,
    classificationMetricsLoading: loading,
    classificationMetricsError: error
  };
};

export default useClassificationMetricList;
